export default __webpack_public_path__ + "static/media/9.14e7db9d.png";